import React from 'react';
import PropTypes from 'prop-types';

import { IconWrapper, UserInitial } from './components';


const ChatUserIcon = ({ user }) => {
  const initials = user.name.split(' ');

  return (
    <IconWrapper>
      <UserInitial>
        {initials[0][0]}{!initials[1] ? null : initials[1][0]}
      </UserInitial>
    </IconWrapper>
  )
};

ChatUserIcon.propTypes = {
  user: PropTypes.object.isRequired
};

export default React.memo(ChatUserIcon);